// src/hooks/useHasPaidSeasons.js
//
// "Does this coach have any money to report on?" — gates the Finances
// nav entry (2026-07-24 sidebar audit: a free-pilot coach staring at a
// Finances tab is noise; a paying coach must never lose it).
//
// One-shot existence check: seasons where coachId == uid AND
// registrationFee > 0, limit 1. Fails OPEN (returns true on error) —
// wrongly showing Finances is a papercut, wrongly hiding it from a
// coach who collects money is a support ticket.
//
// Known limit: club PROGRAM fees live elsewhere, but club admins get
// their own Club section; this hook only gates the solo-coach entry.

import { useEffect, useState } from 'react';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '@/firebase/firebase';

export default function useHasPaidSeasons(uid) {
  const [hasPaid, setHasPaid] = useState(false);

  useEffect(() => {
    if (!uid) { setHasPaid(false); return undefined; }
    let cancelled = false;
    getDocs(query(
      collection(db, 'seasons'),
      where('coachId', '==', uid),
      where('registrationFee', '>', 0),
      limit(1),
    ))
      .then((snap) => { if (!cancelled) setHasPaid(!snap.empty); })
      .catch(() => { if (!cancelled) setHasPaid(true); }); // fail open
    return () => { cancelled = true; };
  }, [uid]);

  return hasPaid;
}
